import { useMemo } from 'react';
import '/assets/styles/sections/home-categories.scss';

// Partials
import CategoryCard from '/views/partials/category-card';
import EmptyMessage from '/views/partials/empty-message';
import Link from '@wearetla/tla-essentials-tools/partials/link';

// Context
import { useBranchSelection } from '/utilities/branch-selection';

const HomeCategories = ({ data }) => {
	const { selectedBranch, initialized } = useBranchSelection();

	const categories = useMemo(() => {
		return data?.categories ?? [false, false, false, false, false, false];
	}, [data]);

	return (
		<section className="section home-categories">
			<div className="wrapper categories-wrap">
				<div className="categories-heading">
					<div className="heading-textwrap">
						<div className="heading-titlewrap">
							<h2 className="heading-title">Kategoriler</h2>
							<p className="heading-subtitle">Canın ne istiyor?</p>
						</div>
					</div>
				</div>
				{(selectedBranch || !initialized) ? (
					<ul className="categories-list">
						{categories.map((category, nth) => (
							<li className="list-item" key={category?.id ?? nth}>
								<CategoryCard className="list-category" category={category} />
							</li>
						))}
					</ul>
				) : (
					<EmptyMessage className="categories-emptymessage">
						Kategorileri görmek için bulunduğunuz "
						<Link href="placeOrder" className="hyperlink">
							Sipariş Ver
						</Link>
						" butonuna tıklayarak QR kodunu okutunuz.
					</EmptyMessage>
				)}
			</div>
		</section>
	);
};

export default HomeCategories;
